export const seoConfig = {
  home: {
    title: 'Innothrust - Transform Your Business with AI-Powered Solutions',
    description: 'Discover cutting-edge AI and technology solutions to accelerate your business growth. Custom software development, AI integration, and digital transformation services for modern enterprises.',
    keywords: 'AI development, software solutions, digital transformation, custom software, AI integration, business automation',
    canonical: '/',
    ogTitle: 'Innothrust - AI-Powered Business Solutions',
    ogDescription: 'Transform your business with our cutting-edge AI and technology solutions. Custom development and digital transformation services.',
    ogImage: '/assets/og-image.jpg',
    twitterCard: 'summary_large_image',
    twitterSite: '@innothrust',
    twitterCreator: '@innothrust'
  },
  about: {
    title: 'About Innothrust - Our AI & Technology Vision',
    description: 'Learn about Innothrust\'s mission to transform businesses through AI and technology. Meet our team of experts committed to innovation excellence.',
    keywords: 'about us, company mission, team, AI experts, technology company',
    canonical: '/about',
    ogTitle: 'About Innothrust - Our Vision & Team',
    ogDescription: 'Discover our mission to revolutionize business through AI and technology. Meet the experts behind our innovative solutions.',
    ogImage: '/assets/about-og.jpg',
    twitterCard: 'summary',
    twitterSite: '@innothrust',
    twitterCreator: '@innothrust'
  },
  contact: {
    title: 'Contact Innothrust - Let\'s Build Your Future',
    description: 'Get in touch with Innothrust to discuss your AI and software development needs. We\'re here to help transform your business with technology.',
    keywords: 'contact us, partnership, consultation, AI solutions, software development',
    canonical: '/contact',
    ogTitle: 'Contact Innothrust - Start Your Transformation',
    ogDescription: 'Ready to transform your business? Contact our team of AI and technology experts for a consultation.',
    ogImage: '/assets/contact-og.jpg',
    twitterCard: 'summary',
    twitterSite: '@innothrust',
    twitterCreator: '@innothrust'
  },
  terms: {
    title: 'Terms of Service - Innothrust',
    description: 'Read the terms of service for Innothrust. Understand your rights and responsibilities when using our AI and technology services.',
    keywords: 'terms of service, legal, AI services, software terms, user agreement',
    canonical: '/terms-of-use',
    ogTitle: 'Terms of Service - Innothrust',
    ogDescription: 'Terms of Service for Innothrust AI and technology solutions. Read our legal agreements and policies.',
    ogImage: '/assets/terms-og.jpg',
    twitterCard: 'summary',
    twitterSite: '@innothrust',
    twitterCreator: '@innothrust'
  },
  privacy: {
    title: 'Privacy Policy - Innothrust Data Protection',
    description: 'Innothrust values your privacy. Learn how we protect and use your data in our AI and technology services.',
    keywords: 'privacy policy, data protection, GDPR, AI privacy, user data',
    canonical: '/privacy-policy',
    ogTitle: 'Privacy Policy - Innothrust',
    ogDescription: 'How Innothrust protects your privacy. Our commitment to data security and transparency in AI services.',
    ogImage: '/assets/privacy-og.jpg',
    twitterCard: 'summary',
    twitterSite: '@innothrust',
    twitterCreator: '@innothrust'
  }
};

export const defaultSEO = {
  title: 'Innothrust - Transform Your Business with AI',
  description: 'AI-powered solutions and custom software development for modern businesses.',
  ogImage: '/assets/default-og.jpg',
  twitterCard: 'summary'
};